"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateFile = exports.sortByOptions = exports.showInfoModal = exports.setViewMode = exports.setTopFolderId = exports.setSortBy = exports.setGlobalFilter = exports.setFolders = exports.setFilter = exports.setFiles = exports.setBreadcrumbFolders = exports.selectNext = exports.selectFolder = exports.selectFirstItem = exports.selectFile = exports.renameFolder = exports.renameFile = exports.removeSelectedItem = exports.persistedKeys = exports.moveToFolder = exports.loadSubFolders = exports.loadData = exports.initialState = exports.init = exports.goToFolder = exports.goFolderUp = exports["default"] = exports.addFolder = exports.addFile = void 0;
var _reduxActions = require("redux-actions");
var _assets = require("../selectors/assets.js");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _last2 = _interopRequireDefault(require("lodash/last"));
var _helpers = require("../helpers.js");
var _config = require("../config.js");
var _handleActions;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var Boilerplate = window.cccisd.boilerplate;
var persistedKeys = exports.persistedKeys = ['currentFolderId', 'viewMode', 'sortBy'];
var sortByOptions = exports.sortByOptions = [{
  value: 'filename',
  label: 'Sort by file name'
}, {
  value: 'newest',
  label: 'Sort by newest'
}];

// Initial state
var initialState = exports.initialState = {
  topFolderId: 0,
  currentFolderId: 0,
  folders: [],
  files: [],
  viewMode: 'thumbnail',
  selectedFolderUp: false,
  selectedFiles: [],
  selectedFolders: [2],
  sortBy: 'newest',
  globalFilter: 'none',
  filter: '',
  isInfoModal: false,
  loadedFolders: []
};

// Actions
var INIT = 'resources/assets/INIT';
var SET_TOP_FOLDER_ID = 'resources/assets/SET_TOP_FOLDER_ID';
var GO_TO_FOLDER = 'resources/assets/GO_TO_FOLDER';
var GO_FOLDER_UP = 'resources/assets/GO_FOLDER_UP';
var SET_VIEW_MODE = 'resources/assets/SET_VIEW_MODE';
var SELECT_FILE = 'resources/assets/SELECT_FILE';
var SELECT_FOLDER = 'resources/assets/SELECT_FOLDER';
var SET_FILES = 'resources/assets/SET_FILES';
var SET_FOLDERS = 'resources/assets/SET_FOLDERS';
var SET_SORT_BY = 'resources/assets/SET_SORT_BY';
var SELECT_NEXT = 'resources/assets/SELECT_NEXT';
var SHOW_INFO_MODAL = 'resources/assets/SHOW_INFO_MODAL';
var SET_FILTER = 'resources/assets/SET_FILTER';
var SET_GLOBAL_FILTER = 'resources/assets/SET_GLOBAL_FILTER';
var SELECT_FIRST_ITEM = 'resources/assets/SELECT_FIRST_ITEM';
var SET_BREADCRUMB_FOLDERS = 'resources/assets/SET_BREADCRUMB_FOLDERS';

// Action Creators
var init = exports.init = (0, _reduxActions.createAction)(INIT);
var setTopFolderId = exports.setTopFolderId = (0, _reduxActions.createAction)(SET_TOP_FOLDER_ID);
var goToFolder = exports.goToFolder = (0, _reduxActions.createAction)(GO_TO_FOLDER);
var goFolderUp = exports.goFolderUp = (0, _reduxActions.createAction)(GO_FOLDER_UP);
var setViewMode = exports.setViewMode = (0, _reduxActions.createAction)(SET_VIEW_MODE);
var selectFile = exports.selectFile = (0, _reduxActions.createAction)(SELECT_FILE);
var selectFolder = exports.selectFolder = (0, _reduxActions.createAction)(SELECT_FOLDER);
var setFiles = exports.setFiles = (0, _reduxActions.createAction)(SET_FILES);
var setFolders = exports.setFolders = (0, _reduxActions.createAction)(SET_FOLDERS);
var setSortBy = exports.setSortBy = (0, _reduxActions.createAction)(SET_SORT_BY);
var selectNext = exports.selectNext = (0, _reduxActions.createAction)(SELECT_NEXT);
var showInfoModal = exports.showInfoModal = (0, _reduxActions.createAction)(SHOW_INFO_MODAL);
var setFilter = exports.setFilter = (0, _reduxActions.createAction)(SET_FILTER);
var setGlobalFilter = exports.setGlobalFilter = (0, _reduxActions.createAction)(SET_GLOBAL_FILTER);
var selectFirstItem = exports.selectFirstItem = (0, _reduxActions.createAction)(SELECT_FIRST_ITEM);
var setBreadcrumbFolders = exports.setBreadcrumbFolders = (0, _reduxActions.createAction)(SET_BREADCRUMB_FOLDERS);
var loadData = exports.loadData = function loadData() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    parentId = _ref.parentId,
    _ref$force = _ref.force,
    force = _ref$force === void 0 ? false : _ref$force,
    _ref$initialLoad = _ref.initialLoad,
    initialLoad = _ref$initialLoad === void 0 ? false : _ref$initialLoad,
    selectedFile = _ref.selectedFile;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch, getState) {
      var result, fileInfo, state, foldersUrl, response, folders, files;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!selectedFile) {
              _context.next = 6;
              break;
            }
            _context.next = 3;
            return _cccisdAxios["default"].get(Boilerplate.route('api.resources.file.index'), {
              params: {
                id: selectedFile
              }
            });
          case 3:
            result = _context.sent;
            fileInfo = result.data.data.find(function (item) {
              return item.id === selectedFile;
            });
            if (fileInfo && !fileInfo.folders_path.endsWith(_config.TRASH_FOLDER_NAME)) {
              parentId = fileInfo.folder_id;
            }
          case 6:
            state = getState().resources.assets;
            if (!parentId) {
              parentId = state.currentFolderId;
            }
            if (!(!force && state.loadedFolders.includes(parentId))) {
              _context.next = 10;
              break;
            }
            return _context.abrupt("return");
          case 10:
            foldersUrl = parentId ? Boilerplate.route('api.resources.folder.show', {
              folder: parentId
            }) : Boilerplate.route('api.resources.folder.show');
            _context.next = 13;
            return _cccisdAxios["default"].get(foldersUrl);
          case 13:
            response = _context.sent;
            if (!parentId) {
              parentId = response.data.data.self.id;
              dispatch(setTopFolderId(parentId));
            }
            if (initialLoad) {
              dispatch(setBreadcrumbFolders(response.data.data.breadcrumbs));
            }

            // Add folders
            folders = response.data.data.folders.map(function (item) {
              return {
                id: item.id,
                name: item.name,
                path: item.path.replace(/^\/public/, '')
              };
            });
            dispatch(setFolders({
              folders: folders,
              parentId: parentId
            }));

            // Add files
            files = response.data.data.files.map(function (item) {
              // item may not actually be published...
              var file = {
                id: item.id,
                name: item.filename,
                folderId: item.folder_id,
                size: item.published !== null ? item.published.size : item.draft.size,
                url: item.published !== null ? item.published.url : item.draft.url,
                metadata: item.published !== null ? item.published.metadata : item.draft.metadata,
                updatedAt: item.updated_at
              };
              if (item.thumbnail) {
                file.thumbnailSmall = item.thumbnail.small_url;
                file.thumbnailLarge = item.thumbnail.large_url;
              }
              return file;
            }); // if (parentId === 1) {
            //     files = [
            //         ...files,
            //         ...new Array(20).fill(1).map((_, index) => ({
            //             id: index + 1000,
            //             name: `image${index}.png`,
            //             folderId: 0,
            //             size: 123456,
            //             url: `https://placeimg.com/320/240/any?id=${index}`,
            //             updatedAt: '2019-04-12 23:34:12',
            //             thumbnailSmall: `https://placeimg.com/320/240/any?id=${index}`,
            //             thumbnailLarge: `https://placeimg.com/320/240/any?id=${index}`,
            //         })),
            //         {
            //             id: 2000,
            //             name: `sound1.mp3`,
            //             folderId: 0,
            //             size: 123456,
            //             url: `http://www.hochmuth.com/mp3/Bloch_Prayer.mp3`,
            //             updatedAt: '2019-04-12 23:34:15',
            //         },
            //         {
            //             id: 2001,
            //             name: `sound2.mp3`,
            //             folderId: 0,
            //             size: 123456,
            //             url: `http://www.hochmuth.com/mp3/Tchaikovsky_Nocturne__orch.mp3`,
            //             updatedAt: '2019-04-12 23:34:15',
            //         },
            //     ];
            // }
            dispatch(setFiles({
              files: files,
              folderId: parentId
            }));
            if (selectedFile) {
              dispatch(selectFile(selectedFile));
            } else {
              dispatch(selectFirstItem());
            }
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var loadSubFolders = exports.loadSubFolders = function loadSubFolders(folders) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dispatch, getState) {
      var getAssetsState, _loadNext, tree;
      return _regeneratorRuntime().wrap(function _callee3$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            getAssetsState = function getAssetsState() {
              return getState().resources.assets;
            };
            _loadNext = /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(folderId, subtree) {
                var subfolders, _iterator, _step, _loop;
                return _regeneratorRuntime().wrap(function _callee2$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      if (getAssetsState().loadedFolders.includes(folderId)) {
                        _context3.next = 3;
                        break;
                      }
                      _context3.next = 3;
                      return dispatch(loadData({
                        parentId: folderId
                      }));
                    case 3:
                      subfolders = getAssetsState().folders.filter(function (item) {
                        return item.parentId === folderId;
                      });
                      _iterator = _createForOfIteratorHelper(subtree);
                      _context3.prev = 5;
                      _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                        var leaf, foundFolder;
                        return _regeneratorRuntime().wrap(function _loop$(_context2) {
                          while (1) switch (_context2.prev = _context2.next) {
                            case 0:
                              leaf = _step.value;
                              foundFolder = subfolders.find(function (item) {
                                return item.name === leaf.name;
                              });
                              if (!(foundFolder && leaf.children.length > 0)) {
                                _context2.next = 5;
                                break;
                              }
                              _context2.next = 5;
                              return _loadNext(foundFolder.id, leaf.children);
                            case 5:
                            case "end":
                              return _context2.stop();
                          }
                        }, _loop);
                      });
                      _iterator.s();
                    case 8:
                      if ((_step = _iterator.n()).done) {
                        _context3.next = 12;
                        break;
                      }
                      return _context3.delegateYield(_loop(), "t0", 10);
                    case 10:
                      _context3.next = 8;
                      break;
                    case 12:
                      _context3.next = 17;
                      break;
                    case 14:
                      _context3.prev = 14;
                      _context3.t1 = _context3["catch"](5);
                      _iterator.e(_context3.t1);
                    case 17:
                      _context3.prev = 17;
                      _iterator.f();
                      return _context3.finish(17);
                    case 20:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee2, null, [[5, 14, 17, 20]]);
              }));
              return function loadNext(_x5, _x6) {
                return _ref4.apply(this, arguments);
              };
            }();
            tree = (0, _helpers.foldersToTree)(folders);
            _context4.next = 5;
            return _loadNext(getAssetsState().currentFolderId, tree);
          case 5:
            return _context4.abrupt("return", (0, _assets.getAllFiles)(getAssetsState()));
          case 6:
          case "end":
            return _context4.stop();
        }
      }, _callee3);
    }));
    return function (_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var addFolder = exports.addFolder = function addFolder(name) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(dispatch, getState) {
      var state, parentFolder, response;
      return _regeneratorRuntime().wrap(function _callee4$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            state = getState().resources.assets;
            parentFolder = state.currentFolderId === state.topFolderId ? {
              path: ''
            } : state.folders.find(function (item) {
              return item.id === state.currentFolderId;
            });
            if (parentFolder) {
              _context5.next = 4;
              break;
            }
            return _context5.abrupt("return", Promise.reject({
              name: 'There is no current folder'
            }));
          case 4:
            _context5.next = 6;
            return _cccisdAxios["default"].post(Boilerplate.route('api.resources.folder.store'), {
              path: "".concat(parentFolder.path, "/").concat(name)
            });
          case 6:
            response = _context5.sent;
            if (!response.data.errors) {
              _context5.next = 9;
              break;
            }
            return _context5.abrupt("return", Promise.reject((0, _helpers.mapErrors)(response.data.errors, {
              path: 'name'
            })));
          case 9:
            _context5.next = 11;
            return dispatch(loadData({
              force: true
            }));
          case 11:
          case "end":
            return _context5.stop();
        }
      }, _callee4);
    }));
    return function (_x7, _x8) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var removeSelectedItem = exports.removeSelectedItem = function removeSelectedItem() {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(dispatch, getState) {
      var state, trashFolderId, trashFolder, response;
      return _regeneratorRuntime().wrap(function _callee5$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            state = getState().resources.assets;
            trashFolder = state.folders.find(function (item) {
              return item.path === "/".concat(_config.TRASH_FOLDER_NAME);
            });
            if (!trashFolder) {
              _context6.next = 6;
              break;
            }
            trashFolderId = trashFolder.id;
            _context6.next = 10;
            break;
          case 6:
            _context6.next = 8;
            return _cccisdAxios["default"].post(Boilerplate.route('api.resources.folder.store'), {
              path: "/".concat(_config.TRASH_FOLDER_NAME)
            });
          case 8:
            response = _context6.sent;
            trashFolderId = response.data.data.id;
          case 10:
            _context6.next = 12;
            return dispatch(moveToFolder(trashFolderId));
          case 12:
            _context6.next = 14;
            return dispatch(selectFirstItem());
          case 14:
          case "end":
            return _context6.stop();
        }
      }, _callee5);
    }));
    return function (_x9, _x0) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var renameFolder = exports.renameFolder = function renameFolder(id, name) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(dispatch, getState) {
      var state, folderInfo, path, response;
      return _regeneratorRuntime().wrap(function _callee6$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            state = getState().resources.assets;
            folderInfo = state.folders.find(function (item) {
              return item.id === id;
            });
            if (folderInfo) {
              _context7.next = 4;
              break;
            }
            return _context7.abrupt("return", Promise.reject({
              name: 'Something wrong'
            }));
          case 4:
            path = folderInfo.path.replace(/\/[^/]+$/, '/' + name);
            _context7.next = 7;
            return _cccisdAxios["default"].put(Boilerplate.route('api.resources.folder.update', {
              folder: id
            }), {
              path: path
            });
          case 7:
            response = _context7.sent;
            if (!response.data.errors) {
              _context7.next = 10;
              break;
            }
            return _context7.abrupt("return", Promise.reject((0, _helpers.mapErrors)(response.data.errors, {
              path: 'name'
            })));
          case 10:
            _context7.next = 12;
            return dispatch(loadData({
              force: true
            }));
          case 12:
          case "end":
            return _context7.stop();
        }
      }, _callee6);
    }));
    return function (_x1, _x10) {
      return _ref7.apply(this, arguments);
    };
  }();
};
var addFile = exports.addFile = function addFile(file) {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(dispatch, getState) {
      var state, currentFolder, filePath, path, formData, response;
      return _regeneratorRuntime().wrap(function _callee7$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            state = getState().resources.assets;
            currentFolder = {};
            if (state.currentFolderId === state.topFolderId) {
              currentFolder = {
                path: ''
              };
            } else {
              currentFolder = (0, _assets.getCurrentFolder)(state);
            }
            if (currentFolder) {
              _context8.next = 5;
              break;
            }
            return _context8.abrupt("return", Promise.reject({
              name: 'There is no current folder'
            }));
          case 5:
            filePath = file.path.includes('/') ? file.path.replace(/\/[^/]+$/, '') : '';
            path = "".concat(currentFolder.path).concat(filePath).replace(/^\//, '');
            formData = new FormData();
            if (path) {
              formData.append('path', path);
            }
            formData.append('file', file);
            _context8.next = 12;
            return _cccisdAxios["default"].post(Boilerplate.route('api.resources.file.store'), formData);
          case 12:
            response = _context8.sent;
            _context8.next = 15;
            return dispatch(loadData({
              force: true
            }));
          case 15:
            return _context8.abrupt("return", response);
          case 16:
          case "end":
            return _context8.stop();
        }
      }, _callee7);
    }));
    return function (_x11, _x12) {
      return _ref8.apply(this, arguments);
    };
  }();
};
var updateFile = exports.updateFile = function updateFile(file) {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(dispatch, getState) {
      var state, currentFolder, formData, response;
      return _regeneratorRuntime().wrap(function _callee8$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            state = getState().resources.assets;
            currentFolder = {};
            if (state.currentFolderId === state.topFolderId) {
              currentFolder = {
                path: ''
              };
            } else {
              currentFolder = (0, _assets.getCurrentFolder)(state);
            }
            if (currentFolder) {
              _context9.next = 5;
              break;
            }
            return _context9.abrupt("return", Promise.reject({
              name: 'There is no current folder'
            }));
          case 5:
            formData = new FormData();
            if (currentFolder.path) {
              formData.append('path', currentFolder.path.replace(/^\//, ''));
            }
            formData.append('file', file);
            _context9.next = 10;
            return _cccisdAxios["default"].post(Boilerplate.route('api.resources.file.store'), formData);
          case 10:
            response = _context9.sent;
            _context9.next = 13;
            return dispatch(loadData({
              force: true
            }));
          case 13:
            return _context9.abrupt("return", response);
          case 14:
          case "end":
            return _context9.stop();
        }
      }, _callee8);
    }));
    return function (_x13, _x14) {
      return _ref9.apply(this, arguments);
    };
  }();
};
var renameFile = exports.renameFile = function renameFile(id, name) {
  return /*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(dispatch, getState) {
      var response;
      return _regeneratorRuntime().wrap(function _callee9$(_context0) {
        while (1) switch (_context0.prev = _context0.next) {
          case 0:
            _context0.next = 2;
            return _cccisdAxios["default"].put(Boilerplate.route('api.resources.file.update', {
              file: id
            }), {
              filename: name
            });
          case 2:
            response = _context0.sent;
            if (!response.data.errors) {
              _context0.next = 5;
              break;
            }
            return _context0.abrupt("return", Promise.reject(response.data.errors));
          case 5:
            _context0.next = 7;
            return dispatch(loadData({
              force: true
            }));
          case 7:
          case "end":
            return _context0.stop();
        }
      }, _callee9);
    }));
    return function (_x15, _x16) {
      return _ref0.apply(this, arguments);
    };
  }();
};
var moveToFolder = exports.moveToFolder = function moveToFolder(destId) {
  return /*#__PURE__*/function () {
    var _ref1 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee0(dispatch, getState) {
      var state, destFolder, _iterator2, _step2, _loop2, _iterator3, _step3, sourceId;
      return _regeneratorRuntime().wrap(function _callee0$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            state = getState().resources.assets;
            destFolder = state.folders.find(function (item) {
              return item.id === destId;
            });
            _iterator2 = _createForOfIteratorHelper(state.selectedFolders);
            _context10.prev = 3;
            _loop2 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop2() {
              var sourceId, sourceFolder, newPath;
              return _regeneratorRuntime().wrap(function _loop2$(_context1) {
                while (1) switch (_context1.prev = _context1.next) {
                  case 0:
                    sourceId = _step2.value;
                    sourceFolder = state.folders.find(function (item) {
                      return item.id === sourceId;
                    });
                    newPath = destFolder.path + '/' + sourceFolder.name;
                    _context1.next = 5;
                    return _cccisdAxios["default"].put(Boilerplate.route('api.resources.folder.update', {
                      folder: sourceId
                    }), {
                      path: newPath
                    });
                  case 5:
                  case "end":
                    return _context1.stop();
                }
              }, _loop2);
            });
            _iterator2.s();
          case 6:
            if ((_step2 = _iterator2.n()).done) {
              _context10.next = 10;
              break;
            }
            return _context10.delegateYield(_loop2(), "t0", 8);
          case 8:
            _context10.next = 6;
            break;
          case 10:
            _context10.next = 15;
            break;
          case 12:
            _context10.prev = 12;
            _context10.t1 = _context10["catch"](3);
            _iterator2.e(_context10.t1);
          case 15:
            _context10.prev = 15;
            _iterator2.f();
            return _context10.finish(15);
          case 18:
            _iterator3 = _createForOfIteratorHelper(state.selectedFiles);
            _context10.prev = 19;
            _iterator3.s();
          case 21:
            if ((_step3 = _iterator3.n()).done) {
              _context10.next = 27;
              break;
            }
            sourceId = _step3.value;
            _context10.next = 25;
            return _cccisdAxios["default"].put(Boilerplate.route('api.resources.file.update', {
              file: sourceId
            }), {
              folderId: destId
            });
          case 25:
            _context10.next = 21;
            break;
          case 27:
            _context10.next = 32;
            break;
          case 29:
            _context10.prev = 29;
            _context10.t2 = _context10["catch"](19);
            _iterator3.e(_context10.t2);
          case 32:
            _context10.prev = 32;
            _iterator3.f();
            return _context10.finish(32);
          case 35:
            _context10.next = 37;
            return dispatch(loadData({
              force: true
            }));
          case 37:
            _context10.next = 39;
            return dispatch(loadData({
              parentId: destId,
              force: true
            }));
          case 39:
          case "end":
            return _context10.stop();
        }
      }, _callee0, null, [[3, 12, 15, 18], [19, 29, 32, 35]]);
    }));
    return function (_x17, _x18) {
      return _ref1.apply(this, arguments);
    };
  }();
};

// Reducer
var _default = exports["default"] = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, INIT, function (state, action) {
  return _objectSpread(_objectSpread({}, state), (0, _pick2["default"])(initialState, ['topFolderId', 'currentFolderId', 'folders', 'files', 'selectedFolderUp', 'selectedFiles', 'selectedFolders', 'globalFilter', 'filter', 'isInfoModal', 'loadedFolders']));
}), SET_TOP_FOLDER_ID, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    topFolderId: action.payload,
    currentFolderId: action.payload
  });
}), GO_TO_FOLDER, function (state, action) {
  if (state.isInfoModal) {
    return state;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    currentFolderId: action.payload,
    selectedFolderUp: true,
    selectedFiles: [],
    selectedFolders: []
  });
}), GO_FOLDER_UP, function (state, action) {
  if (state.currentFolderId === state.topFolderId || state.isInfoModal) {
    return state;
  }
  var currentFolder = state.folders.find(function (item) {
    return item.id === state.currentFolderId;
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    currentFolderId: currentFolder.parentId,
    selectedFolderUp: false,
    selectedFiles: [],
    selectedFolders: [state.currentFolderId]
  });
}), SET_VIEW_MODE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    viewMode: action.payload
  });
}), SELECT_FILE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    selectedFolderUp: false,
    selectedFiles: [action.payload],
    selectedFolders: []
  });
}), SELECT_FOLDER, function (state, action) {
  if (action.payload === -1) {
    return _objectSpread(_objectSpread({}, state), {}, {
      selectedFolderUp: true,
      selectedFiles: [],
      selectedFolders: []
    });
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    selectedFolderUp: false,
    selectedFiles: [],
    selectedFolders: [action.payload]
  });
}), SET_FILES, function (state, action) {
  var _action$payload = action.payload,
    files = _action$payload.files,
    folderId = _action$payload.folderId;
  if (folderId === undefined) {
    folderId = state.currentFolderId;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    files: [].concat(_toConsumableArray(state.files.filter(function (file) {
      return file.folderId !== folderId;
    })), _toConsumableArray(files.map(function (file) {
      return _objectSpread(_objectSpread({}, file), {}, {
        folderId: folderId
      });
    })))
  });
}), SET_FOLDERS, function (state, action) {
  var _action$payload2 = action.payload,
    folders = _action$payload2.folders,
    parentId = _action$payload2.parentId;
  if (parentId === undefined) {
    parentId = state.currentFolderId;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    folders: [].concat(_toConsumableArray(state.folders.filter(function (folder) {
      return folder.parentId !== parentId;
    })), _toConsumableArray(folders.map(function (folder) {
      return _objectSpread(_objectSpread({}, folder), {}, {
        parentId: parentId
      });
    }))),
    loadedFolders: state.loadedFolders.includes(parentId) ? state.loadedFolders : [].concat(_toConsumableArray(state.loadedFolders), [parentId])
  });
}), SET_SORT_BY, function (state, action) {
  if (!sortByOptions.find(function (item) {
    return item.value === action.payload;
  })) {
    return state;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    sortBy: action.payload
  });
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, SELECT_NEXT, function (state, action) {
  var currentFolderId = state.currentFolderId,
    topFolderId = state.topFolderId,
    selectedFolderUp = state.selectedFolderUp,
    isInfoModal = state.isInfoModal;
  var _getCurrentFolderData = (0, _assets.getCurrentFolderData)(state),
    folders = _getCurrentFolderData.folders,
    files = _getCurrentFolderData.files;
  var oneSelectedFile = (0, _assets.getOneSelectedFile)(state);
  var oneSelectedFolder = (0, _assets.getOneSelectedFolder)(state);
  var items = [{
    id: -1
  }].concat(_toConsumableArray(folders), _toConsumableArray(files));
  var steps = action.payload || 1;
  if (!oneSelectedFolder && !oneSelectedFile && !selectedFolderUp) {
    return state;
  }
  var newIndex = 0;
  if (oneSelectedFolder) {
    newIndex = folders.findIndex(function (item) {
      return item.id === oneSelectedFolder.id;
    }) + 1;
  } else if (oneSelectedFile) {
    newIndex = files.findIndex(function (item) {
      return item.id === oneSelectedFile.id;
    }) + 1 + folders.length;
  }
  newIndex += steps;
  var foundItem = items[newIndex];
  if (!foundItem) {
    return state;
  }

  // if folderUp
  if (foundItem.id === -1) {
    return currentFolderId === topFolderId || isInfoModal ? state : _objectSpread(_objectSpread({}, state), {}, {
      selectedFolderUp: true,
      selectedFolders: [],
      selectedFiles: []
    });
  }

  // if folder
  if (foundItem.parentId !== undefined) {
    return _objectSpread(_objectSpread({}, state), {}, {
      selectedFolderUp: false,
      selectedFolders: [foundItem.id],
      selectedFiles: []
    });
  }

  // if file
  return _objectSpread(_objectSpread({}, state), {}, {
    selectedFolderUp: false,
    selectedFolders: [],
    selectedFiles: [foundItem.id]
  });
}), SHOW_INFO_MODAL, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isInfoModal: action.payload === false ? false : true
  });
}), SET_FILTER, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    filter: action.payload,
    selectedFolders: [],
    selectedFiles: []
  });
}), SET_GLOBAL_FILTER, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    globalFilter: action.payload
  });
}), SELECT_FIRST_ITEM, function (state, action) {
  var currentFolderId = state.currentFolderId,
    topFolderId = state.topFolderId;
  var _getCurrentFolderData2 = (0, _assets.getCurrentFolderData)(state),
    folders = _getCurrentFolderData2.folders,
    files = _getCurrentFolderData2.files;
  var isAnySelected = (0, _assets.getIsAnySelected)(state);
  if (isAnySelected) {
    return state;
  }
  if (currentFolderId !== topFolderId) {
    return _objectSpread(_objectSpread({}, state), {}, {
      selectedFolderUp: true,
      selectedFolders: [],
      selectedFiles: []
    });
  }
  if (folders.length > 0) {
    return _objectSpread(_objectSpread({}, state), {}, {
      selectedFolderUp: false,
      selectedFolders: [folders[0].id],
      selectedFiles: []
    });
  }
  if (files.length > 0) {
    return _objectSpread(_objectSpread({}, state), {}, {
      selectedFolderUp: false,
      selectedFolders: [],
      selectedFiles: [files[0].id]
    });
  }
  return state;
}), SET_BREADCRUMB_FOLDERS, function (state, action) {
  var existingFolderIds = state.folders.map(function (item) {
    return item.id;
  });
  var topFolder = action.payload.find(function (item) {
    return !item.parent_id;
  });
  var currentFolder = (0, _last2["default"])(action.payload);
  return _objectSpread(_objectSpread(_objectSpread({}, state), {}, {
    folders: [].concat(_toConsumableArray(state.folders), _toConsumableArray(action.payload.filter(function (item) {
      return !existingFolderIds.includes(item.id) && item.parent_id;
    }).map(function (item) {
      return {
        id: item.id,
        name: item.name,
        path: item.path.replace(/^\/public/, ''),
        parentId: item.parent_id
      };
    })))
  }, topFolder && {
    topFolderId: topFolder.id
  }), {}, {
    currentFolderId: currentFolder.id
  });
})), initialState);